var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    color: "#5E639B",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.701 0.666748H5.2975C2.74326 0.666748 0.666016 2.74401 0.666016 5.29826V22.7019C0.666016 25.2564 2.74326 27.3334 5.2975 27.3334H22.701C25.2554 27.3334 27.3325 25.2562 27.3325 22.7019L27.3327 5.29826C27.3327 2.74401 25.2554 0.666748 22.7012 0.666748H22.701ZM20.3712 18.6879C20.8484 19.1651 20.8484 19.8949 20.3712 20.3723C20.1466 20.5969 19.8378 20.709 19.529 20.709C19.2202 20.709 18.9115 20.5969 18.6869 20.3723L13.9992 15.6845L9.31143 20.3723C9.08684 20.5969 8.77805 20.709 8.46928 20.709C8.16049 20.709 7.85173 20.5969 7.62712 20.3723C7.14995 19.8951 7.14995 19.1653 7.62712 18.6879L12.3148 14.0002L7.62712 9.31243C7.14995 8.83526 7.14995 8.1055 7.62712 7.6281C8.10429 7.15093 8.83404 7.15093 9.31143 7.6281L13.9992 12.3159L18.6869 7.6281C19.164 7.15093 19.8938 7.15093 20.3712 7.6281C20.8484 8.10528 20.8484 8.83503 20.3712 9.31243L15.6835 14.0002L20.3712 18.6879Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.f3f6e352454f33dad3ea765a551b44f7.svg";
export { ForwardRef as ReactComponent };